import { CSSProperties } from 'react';
import { SxProps, Theme } from '@mui/material/styles';

export const serviceRequestStyles = {
    successRoot: {
        maxWidth: 560,
        mx: 'auto',
        textAlign: 'center',
        py: 8,
    } satisfies SxProps<Theme>,
    successIconWrap: {
        width: 64,
        height: 64,
        borderRadius: '50%',
        bgcolor: 'success.light',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        mx: 'auto',
        mb: 2,
    } satisfies SxProps<Theme>,
    root: {
        maxWidth: 600,
        mx: 'auto',
        display: 'flex',
        flexDirection: 'column',
        gap: 3,
    } satisfies SxProps<Theme>,
    header: {
        display: 'flex',
        alignItems: 'center',
        gap: 2,
    } satisfies SxProps<Theme>,
    formPaper: {
        border: '1px solid',
        borderColor: 'divider',
        borderRadius: 2,
        p: 3,
    } satisfies SxProps<Theme>,
    form: {
        display: 'flex',
        flexDirection: 'column',
        gap: 3,
    } satisfies SxProps<Theme>,
    vinPaper: {
        px: 2,
        py: 1,
        bgcolor: 'grey.50',
        borderRadius: 1,
    } satisfies SxProps<Theme>,
    selectLoadingAdornment: {
        ml: 1,
    } satisfies SxProps<Theme>,
    odometerGrid: {
        display: 'grid',
        gridTemplateColumns: '1fr 1fr',
        gap: 2,
    } satisfies SxProps<Theme>,
    uploadZone: {
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        border: '2px dashed',
        borderColor: 'divider',
        borderRadius: 2,
        py: 5,
        cursor: 'pointer',
        '&:hover': {
            borderColor: 'primary.main',
            bgcolor: 'primary.50',
        },
        transition: 'all 0.2s',
    } satisfies SxProps<Theme>,
    attachments: {
        display: 'flex',
        flexWrap: 'wrap',
        gap: 1,
        mt: 1.5,
    } satisfies SxProps<Theme>,
    actions: {
        display: 'flex',
        justifyContent: 'flex-end',
        gap: 2,
        borderTop: '1px solid',
        borderColor: 'divider',
        pt: 2,
    } satisfies SxProps<Theme>,
};

export const serviceRequestUploadIconStyles: CSSProperties = {
    marginBottom: 8,
};

export const serviceRequestHiddenInputStyles: CSSProperties = {
    display: 'none',
};
